module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_pp1_8011.b7b80487.png";